"use strict";

DecacheImageDirective.$inject = ['config'];
function DecacheImageDirective(config) {
  return {
    restrict: 'EA',
    replace: true,
    scope:  {
      "src": "=imgSrc"
    },
    link: function(scope, element) {
      scope.apiBase = config.apiBase;
      scope.currentTime = new Date().getTime();
      scope.$on('imageChanged', function() {
        element[0].src = scope.apiBase + '/files/' + scope.src + '?decache=' + new Date().getTime();
      });
    },
    template: '<img src="{{apiBase}}/files/{{src}}?decache={{currentTime}}">'
  };
}

angular.module('dokiv')
  .directive('decacheImage', ['config', DecacheImageDirective]);


//////////////////
// WEBPACK FOOTER
// ./scripts/app/DecacheImage.js
// module id = 239
// module chunks = 0